<template>
  <div class="template-navbar">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索模块"
        class="search-input"
        prefix-icon="el-icon-search"
        @input="handleSearch"
      >
      </el-input>
      <el-button
        type="primary"
        size="mini"
        class="buttonSearch"
        @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <!-- 分类标签 -->
    <div class="category-tabs">
      <div
        v-for="(category, index) in categories"
        :key="index"
        @click="oncategory(category)"
        :class="{ categoryactive: category.industryId == activeCategory }"
        style="
          cursor: pointer;
          margin-bottom: 5px;
          padding: 5px 5px;
          height: 29px;
          border-radius: 5px;
        "
      >
        {{ category.industryName }}
      </div>
    </div>
    <el-empty
      v-if="contentItems.length === 0"
      :image-size="200"
      style="margin-top: 50px"
    ></el-empty>
  </div>
</template>
<script>
export default {
  name: "StyleNavbar",
  data() {
    return {
      searchKeyword: "",
      hoverIndex: -1, // 悬浮状态索引
      activeCategory: "all",
      categories: [
        {
          industryId: 1,
          industryName: "标题",
        },
        {
          industryId: 2,
          industryName: "正文",
        },
        {
          industryId: 3,
          industryName: "图文",
        },
        {
          industryId: 4,
          industryName: "引导",
        },
        {
          industryId: 5,
          industryName: "SVG",
        },
        {
          industryId: 6,
          industryName: "布局",
        },
        {
          industryId: 7,
          industryName: "节日",
        },
        {
          industryId: 8,
          industryName: "行业",
        },
        {
          industryId: 9,
          industryName: "小元素",
        },
      ],
      contentItems: [],
    };
  },
  created() {
    this.industry();
  },
  methods: {
    async industry() {
      this.categories = [
        { industryId: "all", industryName: "全部" },
        ...this.categories,
      ];

      console.log("leftTweet子组件获取行业分类数据----", this.categories);
    },
    handleSearch() {
      this.$emit("search", this.searchKeyword);
    },
    handleQuery() {
      this.$emit("query", this.searchKeyword);
    },
    oncategory(item) {
      console.log("分类点击", item);
      this.activeCategory = item.industryId;
      this.$emit("changeTab", item);

      return;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
.template-navbar {
  border: 2px solid red;
  /* 搜索栏样式 */
  .search-bar {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }

  .search-input {
    ::v-deep .el-input__inner {
      height: 30px !important;
      line-height: 30px;
    }
    ::v-deep .el-input__icon {
      line-height: 30px;
    }
  }

  .buttonSearch {
    background-color: #348cf8;
    height: 29px;
    border-radius: 6px;
    margin-left: 5px;
    border-color: #348cf8;
  }

  /* 分类标签样式 */
  .category-tabs {
    margin-bottom: 24px;
    font-size: 14px;
    display: flex;
    gap: 0 37px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .categoryactive {
      background-color: #edf0fc;
      color: #4c6ee2;
    }
  }
}
</style>
